<template>
  <span>
    <v-list-item
      v-for="item in items"
      :key="item.id"
      :class="[item.active ? '' : 'grey--text']"
      class="mx-8"
    >
      <v-list-item-avatar>
        <v-icon :color="item.active ? 'primary' : 'grey--text'">{{
          item.icon
        }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.title }}
        </v-list-item-title>
        <v-list-item-subtitle :class="[item.active ? '' : 'grey--text']">
          {{ item.subTitle }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-btn-toggle v-if="item?.size" v-model="item.size" mandatory dense>
        <v-btn
          v-for="size in DASHBOARD_WIDGET_SIZES"
          :key="size.value"
          :value="size.value"
          active-class="white--text primary font-weight-medium"
          x-small
        >
          {{ size.text }}
        </v-btn>
      </v-btn-toggle>

      <v-list-item-action>
        <v-checkbox
          v-model="item.active"
          :color="item.active ? 'primary' : 'grey'"
        ></v-checkbox>
      </v-list-item-action>
    </v-list-item>
  </span>
</template>
<script>
import { DASHBOARD_WIDGET_SIZES } from "@/store/util/dashboardUtils";
export default {
  name: "DashboardItemsConfigList",
  props: ["items"],
  data() {
    return { DASHBOARD_WIDGET_SIZES };
  },
};
</script>
